import TableSkeleton from './table-skeleton';

export default function PaiementTableSkeleton() {
    const columns = ['No Reçu', 'Date', 'Station', 'Montant payé (USD)', 'Mode paiement'];

    return <TableSkeleton rows={5} columns={columns} />;
}
